<template>
<div>
<Subtitle  v-bind:ServiceID="this.id">
<template v-slot:header>
<i class="fas fa-book-reader"></i><b> {{Title}} Bulletins:</b>
</template> 
</Subtitle> 
 <Card v-if="showEdit">
  <CardBody>
    <p>Manage Bulletins is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p>
</CardBody>
</Card> 

<b-modal id="modal-sm" size="md" title="Delete Bulletin" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
    <div slot="default">
        <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
        <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
    </div> 
    <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button variant="primary"  size="md"  class="float-right"  v-on:click="ClosePopUp"> Close </b-button>
    </div>
</b-modal>
<b-modal id="editModal" v-model="showEditModal"  no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
     header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
     <BulletinsAddEdit v-if="showEditModal==true" :UserData="UserData" :Button="Button" @bulletinUpdated="closeModal"></BulletinsAddEdit>
     <template slot="modal-header"   slot-scope="{ close }"> 
        <div>
        <small class="PopUpTitle w-100 text-left">{{Button}} Bulletin</small>
      </div> 
      <div v-show="Button=='Edit'"></div>
    </template>  
</b-modal>
<v-client-table :columns="columns" :data="tableData" :options="options">
    <!-- <span class="pointer" v-on:click="DeleteBulletinPopup(props.row)" slot="delete" slot-scope="props" ><i class="fas fa-trash"></i></span> -->
    <span class="pointer" v-on:click="DeleteBulletinMsgBox('Are you sure you want to delete this bulletin ('+ props.row.bulletinname +') ?'   ,props.row)" slot="delete" slot-scope="props" >
        <i class="far fa-trash-alt"></i></span>
    <span class="pointer" v-on:click="EditBulletinPopup(props.row)" slot="edit" slot-scope="props" ><i class="far fa-edit"></i></span>
    <span class="pointer"  v-on:click="getPDF(props.row)" slot="bulletinname" slot-scope="props" ><u>{{props.row.bulletinname}}</u></span>
    <div   v-if="showEdit" slot="beforeFilter"  class="VueTables_Adduser">
    <label for="VueTables_Adduser" class="VueTables_user"> Add New Bulletin: </label>
        <button type="button" v-on:click="AddBulletinPopup" class="btn btn-primary form-control mr-2" >ADD BULLETIN</button>
    </div>
</v-client-table>   
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import TileNote from "@/Common/TileNote.vue";
import Modal from '../../../Common/ModelPop.vue';
import Subtitle from '@/Common/Default/SubTitle.vue';  
import BulletinsAddEdit from '@/components/DPEBB/Administrator/BulletinsAddEdit.vue';
export default {
    props:{
      Mode:'',
      Type:'',
    },
    data: function(){
        return {
            MainTitle: 'EDS Administration Application',
            MainIcon:'fas fa-file-prescription',
            Title:'Manage',            
            doc64String:'',            
            bulletinname:'',
            showEdit:true,
            showPDF:false,
            size:'',
            id:'',
            showEditModal:false,
            showModal:false,
            succeeded:false,
            Msg:'',
            Button:'',
            PopUpVar:PopUpVariant,
            columns: ['delete','edit' ,'bulletinname','name','effectivedate','postdate', 'expirydate','createuser','createddatetime','updateuser','lastmodifieddatetime'],
            tableData: [],
            options: {
                texts:{
                    count:"Showing {from} to {to} of {count} records|{count} records|One record",
                    first:'First',
                    last:'Name',
                    filter:"Search Bulletin Data:",
                    filterPlaceholder:"Search in table",
                    limit:"Records:",
                    page:"Page:",
                    noResults:"No matching records",
                    filterBy:"Filter by {column}",
                    loading:'Loading...',
                    defaultOption:'Select {column}',
                    columns:'Columns'
                }, 
            
       
                responseAdapter({data}) {
                
                    return {
                    data: formatData,
                    count: data.length
                    };
                    
                },
         
                perPage:10,
                perPageValues:[10,15,25],
                dateColumns:['effectivedate','expirydate', 'createddatetime'],
                toMomentFormat: 'YYYY-MM-DD',
                   
                templates: {
                    effectivedate(h, row){
                        return moment(row.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
                    },
                    postdate(h, row) {
                        return moment(row.postdate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
                    },
                    expirydate(h, row) {
                        return moment(row.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
                    },
                    createddatetime(h, row){
                        return moment(row.createddatetime, "YYYY-MM-DD").format('YYYY/MM/DD'); 
                    },
                    lastmodifieddatetime(h, row){
                        return moment(row.lastmodifieddatetime, "YYYY-MM-DD").format('YYYY/MM/DD'); 
                    },
                },
                    
                headings: {
                    delete:'Delete',
                    edit: 'Edit',
                    bulletinname: 'Bulletin Name',
                    name: 'Service Type',
                    effectivedate: 'Effective Date',
                    postdate: 'Post Date',
                    expirydate: 'Expiry Date',
                    createuser: "Created By",
                    createddatetime: "Created Date",
                    updateuser: 'Last Modified By',
                    lastmodifieddatetime: "Last Modified Date"
                },
                pagination: {
                    edge: true,
                    nav: 'scroll',
                    chunk: 5
                },
                sortable: ['bulletinname','name','effectivedate','postdate', 'expirydate','createuser','createddatetime','updateuser','lastmodifieddatetime'],
                filterable:  ['bulletinname','name','effectivedate','postdate', 'expirydate','createuser','createddatetime','updateuser','lastmodifieddatetime'],
                sortIcon: {
                    base : 'fas',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down'
                },
            }
        }
    },
    components: {

        Modal:Modal,
        Card,
        CardBody,
        TileNote,
        BulletinsAddEdit,
        Subtitle
    },   
    created:function(){
      
        this.showEdit=this.Mode;
        this.id = this.Type;
        this.loadTable();
        if(this.id=="1")
        {
            this.MainIcon = 'fas fa-tooth';
            this.MainTitle ='Dental Application';
        }
        else if(this.id=="2")
        {
             this.MainIcon = 'fas fa-hospital-alt';
              this.MainTitle ='Medical Application';
        }
        else if(this.id=="3")
        {
             this.MainIcon = 'fas  fa-glasses';
              this.MainTitle ='Optical Application';
        }
        else if(this.id=="4")
        {
             this.MainIcon = 'fas fa-assistive-listening-systems';
              this.MainTitle ='Hearing Application';
        }
        else if(this.id=="5")
        {
             this.MainIcon = 'fas  fa-shoe-prints';
              this.MainTitle ='Podiatry Application';
        }
        else if(this.id=="6")
        {
             this.MainIcon = 'fas fa-file-prescription';
              this.MainTitle ='EDS Administration Application';
        }

    },
    mounted:function(){
     if (!this.showEdit) {
      this.columns.splice(this.columns.findIndex(column => column == 'edit'), 1);
      this.columns.splice(this.columns.findIndex(column => column == 'delete'), 1);
       this.columns.splice(this.columns.findIndex(column => column == 'postdate'), 1);
       this.Title="View";
     }
     else
     {
          this.Title="Manage";
     }
    },
    computed:{
        UserName(){
           return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
        }
    }, 
    methods:{
        closeModal() { 
            this.showEditModal = false;
            this.loadTable();
        },
        ClosePopUp(){
            this.showModal = false;
        },
        AddBulletinPopup:function(Rowdata){
            this.Button='Add';
            this.UserData = Rowdata;
            this.showEditModal=true;
        },
        DeleteBulletinMsgBox(msg,data) {
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm(msg, {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true, 
          
        })
          .then(value => {
            this.boxTwo = value
            if(value)
            {
            var vm = this;
            var url = "SaskHealthApi/Security/DeleteBulletin/bulletinId/"

            //  var params = new URLSearchParams();

                 var params = {
                "_": Date.now(),
                "bulletinId":  data.id
                } 
        //  params.append("bulletinId", vm.id);
         axios.delete(url, { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
            .then(function (response) {
                    vm.succeeded = true;
                    vm.Msg= 'Bulletin ' + data.bulletinname + ' is successfully deleted.',
                     vm.showModal = true;
                    vm.loadTable();
                
                })
                .catch(function (er) {
                    //console.log(er)
                    vm.succeeded = false;
                    vm.Msg= 'Bulletin ' + data.bulletinname + ' is not successfully deleted.',
                    vm.showModal = true;
                });

            }
          })
          .catch(err => {
              //console.log(err);
          })
      },
        EditBulletinPopup:function(Rowdata){
            this.Button='Edit';
            this.UserData = Rowdata;
            this.showEditModal=true;
        },
        loadTable(){ 
        var vm = this;
        var url = 'SaskHealthApi/Security/GetBulletins?_='

         var params = new URLSearchParams();
         params.append("id", vm.id);
         axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
            .then(function (response) {
               
                vm.tableData=response.data;
                
                })
                .catch(function (er) {
                    //console.log(er)
                });
          },
        getPDF:function(Rowdata){ 
        const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];        
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
        }  

            var vm = this;
            var url = 'SaskHealthApi/Security/GetPDF?_='
            var params = new URLSearchParams();
            params.append("id", Rowdata.id);
            // const params = { 
            //    id: Rowdata.id,
            //};
            axios.get(url+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
            .then(function (response) {
                const contentType = 'application/pdf';
                const blob = b64toBlob(response.data.pdf , contentType); 
                // const blobUrl = URL.createObjectURL(blob); 
                // const downloadLink = document.createElement("a");
                const fileName = Rowdata.pdfname; 
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    var byteCharacters = atob(response.data.pdf);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i=0;i<byteCharacters.length;i++){
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var blobIE = new Blob([byteArray],{type: 'application.pdf'});
                    window.navigator.msSaveOrOpenBlob(blobIE,fileName);
                }
                else
                {
                    //console.log("here at open _blank"); 
                    var win = open('', '_blank'); 
                    win.document.write(
                        '<html><body><center>' +
                        '<a title="Download PDF" style="font-family: \'Verdana\';color: #333;text-decoration: none;font-weight: 600;" download="' + Rowdata.pdfname + '" href="data:application/pdf;base64,' + response.data.pdf + '">Download File</a>' +
                        '</center><br>' +
                        '<object width=100% height=100% type="application/pdf" data="data:application/pdf;base64,' + response.data.pdf  + '">' +
                        '<embed type="application/pdf" src="data:application/pdf;base64,' + response.data.pdf  + '" id="embed_pdf"></embed>' +
                        '</object></body></html>'); 
                 }
            })
            .catch(function (er) {
                 //console.log(er)
            });
            
        }
    }
}
</script>

<style>

</style>
